module.exports = __webpack_public_path__ + "static/logo-white-93cf38046d8621b64bc635f025fa1015.png";